import { Routes, Route, Navigate, useNavigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { history, handleTokenExpiration } from '_helpers'; // Import the function here
import { Nav, Alert, PrivateRoute } from '_components';
import { Home } from 'home';
import { LinkedInCallback } from './account/LinkedInCallback';
import { AccountLayout } from 'account';
import { UsersLayout } from 'users';
import { MapLayout } from 'maps';
import { ServicesLayout } from 'services';
import { DronePayload } from 'dronepayload';
import { LandingPage } from './landing';
import { JobPostings } from './jobpostings/JobPostings';
import { JobOpenings } from './jobpostings/JobOpenings';
import { AdminJobReview  } from './jobpostings/AdminJobReview';
import { SuperAdmin } from "./jobpostings/SuperAdmin";
import { MasterLogin } from './jobpostings/MasterLogin';
import { UsersList } from './jobpostings/UsersList';
import { List } from './users/List';
import { Leads } from './leads';
//import { ApplyJobs } from "./jobpostings/ApplyJobs";  
import ApplyJobs from './jobpostings/ApplyJobs';
import { TermsOfUse } from './termsandconditions'; 
import { ContactSalesForm, Map, ProviderAndCustomerDetail, ProviderDetails } from './customer'; // Import customer components
import { useEffect, useLayoutEffect  } from 'react';


export { App };

function App() {
    // init custom history object to allow navigation from 
    // anywhere in the react app (inside or outside components)
    history.navigate = useNavigate();
    history.location = useLocation();
    const auth = useSelector(state => state.auth.value);

    useEffect(() => {
        handleTokenExpiration();

        const intervalId = setInterval(() => handleTokenExpiration(), 60000);

        return () => clearInterval(intervalId);
    }, []);

    return (
        <div className="app-container bg-light">
            <Nav />
            <Alert />
            <div className="container pt-4 pb-4">
                <Routes>
                    {/* Redirect authenticated users away from LandingPage */}
                    {/* <Route 
                        path="/" 
                        element={<LandingPage />} 
                    /> */}
                    <Route 
                        path="/" 
                        element={auth ? <Navigate to="/home" /> : <LandingPage />} 
                    />
                    <Route path="account/*" element={<AccountLayout />} />
                    
                    {/* Public Routes for customer components */}
                        <Route path="map" element={<Map />} />
                        <Route path="providerdetails" element={<ProviderDetails />} />
                        <Route path="contactsalesform" element={<ContactSalesForm />} />
                        <Route path="providerandcustomerdetail" element={<ProviderAndCustomerDetail />} />
                        <Route path="/linkedin-callback" element={<LinkedInCallback />} />
                        <Route path='/jobpostings' element={<JobPostings />} />
                        <Route path='/jobopenings' element={<JobOpenings />} />
                        <Route path="/review-job/:jobId" element={<AdminJobReview />} />
                        <Route path="/masterlogin" element={<MasterLogin />} />
                        <Route path='/superadmin' element={<SuperAdmin />} />
                        <Route path='/userslist' element={<UsersList />} />
                        

                    {/* Private Routes */}
                    <Route element={<PrivateRoute />}>
                        <Route path="/home" element={<Home />} />
                        <Route path="users/*" element={<UsersLayout />} />
                        <Route path="maps/*" element={<MapLayout />} />
                        <Route path="services/*" element={<ServicesLayout />} />
                        <Route path="dronepayload/*" element={<DronePayload />} />
                        <Route path="list/*" element={<List />} />
                        <Route path="/leads" element={<Leads />} />
                        <Route path="termsofuse/*" element={<TermsOfUse />} />
                        <Route path="/applyjobs" element={<ApplyJobs />} />
                        
                       
                        
                    </Route> 
                    <Route path="*" element={auth ? <Navigate to="/" /> : <Navigate to="/" />} />
                </Routes>
            </div>
        </div>
    );
}
